import React from 'react';
import classNames from 'classnames';
import BulletedMatchedRuleDescription from 'components/triggers/BulletedMatchedRuleDescription';

const renderDescription = item => {
  const isTriggerNotification =
    item.context.type === 'trigger_notification' || 'trend_notification';

  const text = item.context.description;
  const timing = item.context.timing;

  // if not grouped, simple description
  if (!item.isGrouped) {
    return (
      <div className="item-description">
        {isTriggerNotification ? (
          <BulletedMatchedRuleDescription text={text} timing={timing} isDetail={true} />
        ) : (
          item.context.description
        )}
      </div>
    );
  }

  // if grouped, add an (amt) footnote if necessary
  // (prevent display if it would be redundant)
  const rolledUpNestedItems = item.groupedItems
    .groupBy(g => g.context.description)
    .mapEntries(([k, v]) => [k, [k, v.size]])
    .toList();

  if (!item.useNestedDescriptions || rolledUpNestedItems.size === 1) {
    return (
      <div className="item-description">
        <div>
          {isTriggerNotification ? (
            <BulletedMatchedRuleDescription text={text} timing={timing} isDetail={true} />
          ) : (
            item.context.description
          )}
        </div>
        {item.groupedItems.size > 1 && (
          <div className="grouping-icon">({item.groupedItems.size})</div>
        )}
      </div>
    );
  }

  // if grouped and multiple different items, show them in a list
  // with the footnote if necessary
  return (
    <div className={classNames('nested-description', 'item-description')}>
      {rolledUpNestedItems.map(([k, v]) => (
        <div className="nested-item" key={k}>
          <div>{k}</div>
          <div>{v > 1 && <span className="grouping-icon">({v})</span>}</div>
        </div>
      ))}
    </div>
  );
};

export default renderDescription;
